import React from "react";
import { Button, Card, Form, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";
import Moment from "moment";
import "moment/locale/id";
import SplitText from "views/SplitText";

function Step1() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  // console.log(valDetail, "KKK");
  Moment.locale("id");
  const tglLahir = Moment(valDetail.tglLahir).format("DD MMMM YYYY");
  const tglkeluarIdentitas = Moment(valDetail.tglKeluarIdentitas).format(
    "DD MMMM YYYY",
  );
  const tglBerlakuSampai = Moment(valDetail.masaBerlakuIdentitas).format(
    "DD MMMM YYYY",
  );
  const jsonTipeNasabah = pengajuan.jsonPengajuan.tipeNasabah;
  const tipeNasabah = jsonTipeNasabah.find((value) => {
    return pengajuan.detailPengajuan.tipeNasabah === value.value;
  });

  return (
    <>
      <Col md="12" style={{ marginTop: 20 }}>
        <Card.Header>
          <Card.Title
            as="h4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              textAlign: "center",
            }}
          >
            {/* <SplitText
              text="informasi nasabah"
              className="text-9xl font-bold text-center"
              delay={100}
              animationFrom={{
                opacity: 0,
                transform: "translate3d(0,50px,0)",
              }}
              animationTo={{
                opacity: 1,
                transform: "translate3d(0,0,0)",
              }}
              easing="easeOutCubic"
              threshold={0.2}
              rootMargin="-50px"
              onLetterAnimationComplete={handleAnimationComplete}
              fontSize="1.5rem"
            /> */}
            informasi nasabah
            <hr></hr>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Card style={{ border: 0 }}>
            <div style={{ maxHeight: "450px", overflowY: "scroll" }}>
              <div className="row">
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    Reffrence ID
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.id_pinjaman}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama lengkap
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.namaLengkap}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                      marginTop: 15,
                    }}
                  >
                    jenis identitas
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 15,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.jenisIdentitas}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nomor identitas
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 15,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.nomorIdentitas}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tempat dikeluarkan identitas
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 15,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.tempatDikeluarkanIdentitas}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tanggal keluar identitas
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 15,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {tglkeluarIdentitas}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    identitas berlaku sampai
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 15,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {tglBerlakuSampai}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    alamat ktp
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.alamatKtp}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    rt ktp
                  </Label>
                  <li>
                    <label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.rt}
                    </label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    rw ktp
                  </Label>
                  <li>
                    <label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.rw}
                    </label>
                  </li>
                </div>
                {/* <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  kode pos ktp
                </Label>
                <li>
                  <label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.kodepos}
                  </label>
                </li>
              </div> */}
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    kelurahan ktp
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.kelurahan}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    domisili sesuai ktp
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.domisiliSesuaiKtp === "true" ? "Ya" : "Tidak"}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nomor kartu keluarga
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.nomorKk}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nomor handphone
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.noHp}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    email
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.email}
                    </Label>
                  </li>
                </div>
                {/* <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  nama panggilan
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.namaPanggilan}
                  </Label>
                </li>
              </div> */}
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tempat lahir
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.tempatLahir}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tanggal lahir
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {tglLahir}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    jenis kelamin
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.jenisKelamin === "L"
                        ? "laki-laki"
                        : "perempuan"}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    agama
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.agama === "1"
                        ? "Islam"
                        : valDetail.agama === "2"
                          ? "Katolik"
                          : valDetail.agama === "3"
                            ? "Kristen Protestan"
                            : valDetail.agama === "4"
                              ? "Hindu"
                              : valDetail.agama === "5"
                                ? "Budha"
                                : valDetail.agama === "6"
                                  ? "Konghucu"
                                  : "Lainnya"}
                    </Label>
                  </li>
                </div>
                {/* <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  status menikah
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.statusMenikah}
                  </Label>
                </li>
              </div> */}
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    status menikah
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.statusMenikah === "Kawin"
                        ? "Kawin"
                        : valDetail.statusMenikah === "Belum Kawin"
                          ? "Belum Kawin"
                          : valDetail.statusMenikah === "Cerai Hidup"
                            ? "Cerai Hidup"
                            : "Cerai Mati"}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama ibu kandung
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.namaIbuKandung}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama waris
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.namaWaris}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    hubungan waris
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.hubunganWaris}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    alamat waris
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.alamatWaris}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    pendidikan
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.pendidikan === "0"
                        ? "Tidak/Belum"
                        : valDetail.pendidikan === "1"
                          ? "SD Sederajat"
                          : valDetail.pendidikan === "2"
                            ? "SMP Sederajat"
                            : valDetail.pendidikan === "3"
                              ? "SMA Sederajat"
                              : valDetail.pendidikan === "4"
                                ? "S1"
                                : valDetail.pendidikan === "5"
                                  ? "S2"
                                  : valDetail.pendidikan === "6"
                                    ? "D1/D2"
                                    : valDetail.pendidikan === "7"
                                      ? "D4"
                                      : valDetail.pendidikan === "8"
                                        ? "D3"
                                        : "S3"}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    gelar
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {valDetail.gelar}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    biaya hidup
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {`Rp ${valDetail.biayaHidup.toLocaleString("id-ID")}`}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tipe nasabah
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {tipeNasabah.label}
                    </Label>
                  </li>
                </div>
                {/* <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  Jenis Asuransi
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.jenisAsuransi}
                  </Label>
                </li>
              </div>
              <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  Biaya Asuransi
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.biayaAsuransi === null
                      ? "-"
                      : `Rp ${valDetail.biayaAsuransi.toLocaleString("id-ID")}`}
                  </Label>
                </li>
              </div>
              <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  Biaya Provisi
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {`Rp ${valDetail.provisi.toLocaleString("id-ID")}`}
                  </Label>
                </li>
              </div>
              <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  Blokir Angsuran
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {`Rp ${valDetail.blokirAngsuran.toLocaleString("id-ID")}`}
                  </Label>
                </li>
              </div>
              <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  Analis
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.analis}
                  </Label>
                </li>
              </div> */}
                {/* <div className="col-6">
                <Label
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#828286",
                    textTransform: "uppercase",
                  }}
                >
                  sid gelar
                </Label>
                <li>
                  <Label
                    style={{
                      fontSize: 14,
                      marginBottom: 15,
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {valDetail.sidGelar === "0100"
                      ? "TANPA GELAR"
                      : valDetail.sidGelar === "0101"
                      ? "DIPLOMA 1"
                      : valDetail.sidGelar === "0102"
                      ? "DIPLOMA 2"
                      : valDetail.sidGelar === "0103"
                      ? "DIPLOMA 3"
                      : valDetail.sidGelar === "0104"
                      ? "STRATA 1"
                      : valDetail.sidGelar === "0105"
                      ? "STRATA 2"
                      : "STRATA 3"}
                  </Label>
                </li>
              </div> */}
              </div>
            </div>
          </Card>
        </Card.Body>
      </Col>
    </>
  );
}
export default Step1;
